import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || "https://ydkjwrsoupsxbfzmspaa.supabase.co";
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || "sb_publishable_WAq5gla3zsqde7q03ALpkw_AF3h-aaC";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const fetchWithTimeout = async <T>(promise: Promise<T>, timeoutMs = 800): Promise<T> => {
  let timeoutId: any;
  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error("Timeout")), timeoutMs);
  });
  return Promise.race([promise, timeoutPromise]).finally(() => clearTimeout(timeoutId));
};

export type Database = {
  public: {
    Tables: {
      products: {
        Row: {
          id: string;
          title: string;
          description: string;
          price: number;
          original_price: number;
          discount_percentage: number;
          image_url: string;
          images: string[];
          brand: string;
          category: string;
          source: string;
          source_url: string;
          rating: number;
          review_count: number;
          in_stock: boolean;
          gender: string;
          colors: string[];
          sizes: string[];
          view_count: number;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["products"]["Row"],
          "id" | "created_at" | "updated_at"
        >;
        Update: Partial<Database["public"]["Tables"]["products"]["Insert"]>;
      };
      price_history: {
        Row: {
          id: string;
          product_id: string;
          price: number;
          recorded_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["price_history"]["Row"],
          "id" | "recorded_at"
        >;
        Update: Partial<
          Database["public"]["Tables"]["price_history"]["Insert"]
        >;
      };
      user_favorites: {
        Row: {
          id: string;
          user_id: string;
          product_id: string;
          created_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["user_favorites"]["Row"],
          "id" | "created_at"
        >;
        Update: Partial<
          Database["public"]["Tables"]["user_favorites"]["Insert"]
        >;
      };
      price_alerts: {
        Row: {
          id: string;
          user_id: string;
          product_id: string;
          target_price: number;
          is_active: boolean;
          created_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["price_alerts"]["Row"],
          "id" | "created_at"
        >;
        Update: Partial<Database["public"]["Tables"]["price_alerts"]["Insert"]>;
      };
      brands: {
        Row: {
          id: string;
          name: string;
          logo_url: string;
          created_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["brands"]["Row"],
          "id" | "created_at"
        >;
        Update: Partial<Database["public"]["Tables"]["brands"]["Insert"]>;
      };
      categories: {
        Row: {
          id: string;
          name: string;
          slug: string;
          parent_id: string | null;
          created_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["categories"]["Row"],
          "id" | "created_at"
        >;
        Update: Partial<Database["public"]["Tables"]["categories"]["Insert"]>;
      };
    };
  };
};
